module.exports = __webpack_public_path__ + "img/arrow-right.6204fa2f.svg";